export default "__VITE_ASSET__BZdebLCe__"